import Vue from 'vue'
import Vuex from 'vuex'
// import store from '@/store'

Vue.use(Vuex)
// export const jumpTo = (item) => {
// item.columnUrl ? this.$router.push(item.columnUrl) : (item.externalLink.includes("http") ? window.open(item.externalLink) : window.open('//' + item.externalLink))
// }
// 图片处理
export const imageProcess = (val) => {
  return val.replace(/ /g, '').replace(/'/g, '').split(',')
}

// 时间转换 2022-02-22 06:32:29 => 年月日
export const timeProcess = (val) => {
  let time = val.slice(0, 10)
  const arr = time.split('-')
  time = arr[0] + '年' + arr[1] + '月' + arr[2] + '日'
  return time || ''
}

// 详情页富文本内容过滤替换操作
export const filterContent = (value) => {
  if (value) {
    let s = value.replace(
      /<img/g,
      '<img style="max-width:100%;height: auto;padding: 5px 0;box-shadow: none"'
    )
    s = s.replace(/<table style="/g, '<table style="margin: 0 auto;')
    s = s.replace(/&lt;/g, '<')
    s = s.replace(/&gt;/g, '>')
    s = s.replace(/&quot;/g, '"')
    s = s.replace(
      /<ul/g,
      "<ul style='list-style: initial;margin: 10px 0 10px 20px;'"
    )
    s = s.replace(
      /<ol/g,
      "<ol style='list-style: decimal;margin: 10px 0 10px 20px;'"
    )
    s = s.replace(/\n/g, '<br>')
    return s
  }
  return ''
}

/**
 * @desc  函数防抖---“立即执行版本” 和 “非立即执行版本” 的组合版本
 * @param  func 需要执行的函数
 * @param  wait 延迟执行时间（毫秒）
 * @param  immediate---true 表立即执行，false 表非立即执行
 **/
export const debounce = (func, wait, immediate) => {
  let timer
  return () => {
    const context = this
    // eslint-disable-next-line no-undef
    const args = arguments
    const later = function () {
      if (immediate) timer = null
      if (!immediate) func.apply(context, args)
    }
    const callNow = immediate && !timer

    if (timer) clearTimeout(timer)
    timer = setTimeout(later, wait)
    if (callNow) func.apply(context, args)
  }
}

/***
 * 节流函数 连续调用，每隔wait时间后触发一次（如:wait设置为300ms，一直点击，每隔300ms执行一次当前点击）
 * @ func 执行函数
 * @ wait 等待时间
 * @ {Boolean} immediate 是否立即执行
 * @return {Function}
 */
export const throttle = (func, wait, immediate) => {
  let timeout
  return () => {
    const context = this
    // eslint-disable-next-line no-undef
    const args = arguments
    const later = function () {
      timeout = null
      if (!immediate) func.apply(context, args)
    }
    const callNow = immediate && !timeout
    if (!timeout) {
      timeout = setTimeout(later, wait)
    }
    if (callNow) func.apply(context, args)
  }
}

/**
 * 判断是否移动端打开
 */
export const isPhone = () => {
  if (
    navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    )
  ) {
    // console.log('移动端');
    return true
  } else {
    return false
  }
}

/**
 * js判断是否是base64字符串
 */
export const isBase64 = (str) => {
  if (str === '' || str.trim() === '') {
    return false
  }
  try {
    return btoa(atob(str)) == str
  } catch (err) {
    return false
  }
}
